import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavoriteH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M59.8 18.1c-5.467-5.467-14.331-5.467-19.799 0l-4 4.002-4.002-4.001c-5.467-5.468-14.331-5.468-19.799 0-5.467 5.467-5.467 14.331 0 19.799l20.575 20.575q.298.297.63.526l.023.015.022.017a4.22 4.22 0 0 0 5.57-.353L59.8 37.9c5.468-5.468 5.468-14.332 0-19.8m-21.213-1.414c6.248-6.248 16.38-6.248 22.627 0 6.249 6.249 6.249 16.38 0 22.628l-20.78 20.78a6.22 6.22 0 0 1-8.188.536 6.6 6.6 0 0 1-.885-.741L10.786 39.314c-6.248-6.248-6.248-16.38 0-22.628s16.379-6.248 22.627 0L36 19.273z",
    clipRule: "evenodd"
  }));
}
var IcFavoriteH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteH72));

export { IcFavoriteH72 as I };
